import AWS from 'aws-sdk';
import { EnquiryTicket, SaleTicket } from 'data/types';

export const sendEmail = async (data: any, mailType: "sale" | "enquiry") => {
    const { email, name, contactPhone, message } = data
    const URL = process.env.REACT_APP_API_URL

    let mailBody;
    let mailSubject;
    let mailTo;

    switch (mailType) {
        case "sale":
            let { makeAndModel, currentMileage, registration } = data as SaleTicket
            mailSubject = `Vehicle Sale - ${makeAndModel}`
            mailBody = `
            <p>Name: ${name}</p>
            <p>Email: ${email}</p>
            <p>Contact Number: ${contactPhone}</p>
            <p>Message: ${message}</p>
            <p>Registration: ${registration}</p>
            <p>Make and Model: ${makeAndModel}</p>
            <p>Current Mileage: ${currentMileage}</p>
            `

            mailTo = "charles@redlinespecialistcars.co.uk"
            break;
        default:
        case "enquiry":
            let { vehicleDetails, vehicleId, url } = data as EnquiryTicket
            mailSubject = `Vehicle Enquiry - ${vehicleDetails}`
            mailBody = `
            <p>Name: ${name}</p>
            <p>Email: ${email}</p>
            <p>Contact Number: ${contactPhone}</p>
            <p>Message: ${message}</p>
            <p>AT Vehicle ID: ${vehicleId}</p>
            <p>Vehicle URL: ${url}</p>
            `

            mailTo = "sales@redlinespecialistcars.co.uk"
            break;
    }

    const params: AWS.SES.SendEmailRequest = {
        Destination: {
            ToAddresses: [mailTo],
        },
        Message: {
            Body: {
                Html: {
                    Charset: 'UTF-8',
                    Data: mailBody,
                },
            },
            Subject: {
                Charset: 'UTF-8',
                Data: mailSubject,
            },
        },
        Source: "\"Redline Enquiries\" <enquiries@redlinespecialistcars.co.uk>",
    };

    try {
        const response = await fetch(`${URL}/mailer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ params })
        })

        const data = await response.json()
        if (response.status === 200 && data) return data
        return false
    } catch (error) {
        console.error(error);
        return error;
    }
}